export default __webpack_public_path__ + "static/home-neural-network-e0566c15a297bcfe5277987b6004035e.svg";